<ng-container *transloco="let t">

  <ng-container *ngIf="worker">

    <ng-container *ngIf="!hasPermissions()">
      <p>{{ t("We don't have any permission data for this worker.") }}</p>
    </ng-container>

    <ng-container *ngIf="hasPermissions()">
      <p>
        {{ t('Permission status for') }} {{ worker.name }},
        {{ t('last updated at') }} {{ worker.permissions.last_update }}.
      </p>

      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col">{{ t('Permission') }}</th>
            <th scope="col">{{ t('Status') }}</th>
            <th scope="col">{{ t('Required') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of permissionRows()">
            <th>{{ row.title }}</th>
            <td>
              <c-badge [color]="statusBadgeColor(row.status)">
                {{ row.label }}
              </c-badge>
            </td>
            <td>{{ row.required ? t('Yes') : t('No') }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

  </ng-container>

</ng-container>
